'use client'

/* eslint-disable @typescript-eslint/no-floating-promises */
import { useEffect } from 'react'
import { WebviewTenant } from '@enums/webview-tenant'
import { genericWebviewHandler, WebViewActions } from '@utils/client/webview'
import { TenantActionValue } from '@configs/webview-tenant-config'
import Cookies from 'js-cookie'

interface IWebviewParams {
  tenant?: WebviewTenant
  tenantPage?: string
}

export const WebviewInitializer = ({ tenant = WebviewTenant.ACKODRIVE }: IWebviewParams) => {
  useEffect(() => {
    const initializeWebview = () => {
      genericWebviewHandler({
        action: WebViewActions.UPDATE_APP_BAR,
        actionValue: TenantActionValue[tenant],
      })
    }
    initializeWebview()
  }, [])
  if (!Cookies.get('native_header_height')) return null
  return <div></div>
}
